import { useEffect, useState } from "react";
import "../../assets/styles/components/notification.scss";
import PerfectScrollbar from "react-perfect-scrollbar";
import { apiGetNotifications, apiGetSystemNotifications, apiReadNotifications } from "api/notificationApi";
// @ts-ignore
import momentJalaali from "moment-jalaali";
import {
  openAccountingDrawer,
  openFactorDrawer,
  openRemittanceDrawer,
  openTransactionDrawer,
  openTransferDrawer,
} from "../../helpers/DrawerActions";
import { notificationDivider } from "helpers/notificationDivider";
import { useAppDispatch, useAppSelector } from "store/store";
import { EyeIcon } from "lucide-react";
import ContainedTabs from "components/Tabs/Tabs3";
import { appSetModal } from "store/actions/appAction";

export default function NotificationBox(props: any) {
  const { showSideNotif, toggleNotif } = props;
  const [valueDefault, setValueDefault] = useState<any[]>([]);
  const notifications = useAppSelector((x) => x.notificationReducer.notifications);
  const businessState = useAppSelector((x) => x.businessReducer);
  const [isAdmin, setNotificationType] = useState<"system" | "business">("business");
  const [adminNotificationCount, setAdminNotificationCount] = useState(0);
  const [isRead, setIsRead] = useState(false);
  const [userNotificationCount, setUserNotificationCount] = useState(0);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (notifications) {
      const notificationData = notificationDivider({ data: notifications, type: isAdmin === "system" });
      setValueDefault(notificationData.filterData);
      setAdminNotificationCount(notificationData.adminNotificationCount);
      setUserNotificationCount(notificationData.userNotificationCount);
    } else {
      setValueDefault([
        {
          title: "تابلو اعلانات چرتکه",
          message: "در این قسمت اعلانات مربوط به فاکتورها، سفارش کالا، چک ها و... برای شما ارسال خواهد شد   ",
        },
      ]);
    }
  }, [notifications]);
  useEffect(() => {
    setValueDefault([])
    if (isAdmin === "system") {
      dispatch(apiGetSystemNotifications((res: any) => {
        setValueDefault(res)

      }));
    } else {
     // dispatch(apiGetNotifications(businessState.business.token, isRead));

    }

    return () => {

    }
  }, [isAdmin])

  const readNotif = (id: number | string, readAll: boolean) => {
    setValueDefault([])
    dispatch(
      apiReadNotifications(businessState?.business?.token, () => {
        dispatch(apiGetNotifications(businessState.business.token));
      }, id, readAll)
    );
  }
  // useEffect(() => {
  //   showSideNotif &&
  //     businessState?.business?.token &&
  //     dispatch(
  //       apiReadNotifications(businessState?.business?.token, () => {
  //         dispatch(apiGetNotifications(businessState.business.token));
  //       })
  //     );
  // }, [showSideNotif, isAdmin]);

  const targetNavigation = (item: any) => {
    if (isAdmin === "system") {
    return    dispatch(
                    appSetModal(
                      {
                        component: "show-system-notification",
                        title: "تغییرات آخرین نسخه",
                        closeButton: true,
                        breadCrumb: [],
                        id: item,
                        parentCode:null,
                        maxWidth: 350
                      },
                      true
                    )
                  );
    }
    readNotif(item.id, false)
    if (item.url) {
      window.open(item.url, "_blank");

    } else if (item.detail_type) {
      switch (item.detail_type.toLowerCase()) {
        case "factor":
          return openFactorDrawer(dispatch, { id: item.detail_id });
        case "transaction":
          return openTransactionDrawer(dispatch, { id: item.detail_id });
        case "transfer":
          return openTransferDrawer(dispatch, { id: item.detail_id });
        case "accounting":
          return openAccountingDrawer(dispatch, { id: item.detail_id });
        case "bill":
          return openRemittanceDrawer(dispatch, { id: item.detail_id });
        // case "installment":
        //   return openInstallmentDrawer(dispatch, { id: item.detail_id });
      }
    }
  };

  return (
    <>
      <div className="right-notification-box" onClick={() => toggleNotif(false)} />
      <div
        className={
          showSideNotif ? "active-wrap-notification-box wrap-notification-box" : "wrap-notification-box"
        }
      >
        <div className="flex flex-row-reverse items-end p-4 bg-white">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="26" viewBox="0 0 21 26" fill="none">
            <path
              d="M19.8884 17.2314L17.9987 14.8683C17.9655 14.8263 17.9476 14.7752 17.9476 14.7228V8.05093C17.9697 6.1846 17.2363 4.38151 15.8989 3.0143C14.5616 1.64709 12.7224 0.82025 10.7616 0.704648C9.73859 0.654603 8.71554 0.80291 7.75476 1.14054C6.79398 1.47816 5.91559 1.99805 5.17308 2.66852C4.43056 3.339 3.83945 4.14605 3.43575 5.04052C3.03205 5.93499 2.8242 6.89817 2.82486 7.8714V14.9702C2.82486 15.0227 2.80694 15.0738 2.77379 15.1158L1.09859 17.2314C0.798876 17.544 0.601176 17.9326 0.529503 18.35C0.45783 18.7674 0.51527 19.1955 0.694845 19.5825C0.874419 19.9694 1.1684 20.2985 1.54108 20.5297C1.91376 20.761 2.3491 20.8844 2.79422 20.8851H18.1775C18.6239 20.8873 19.0613 20.7659 19.4363 20.5357C19.8113 20.3056 20.1076 19.9767 20.2891 19.5892C20.4705 19.2016 20.5293 18.7723 20.4581 18.3536C20.387 17.9349 20.189 17.5449 19.8884 17.2314ZM18.8669 18.9782C18.8091 19.1087 18.7117 19.22 18.5871 19.2978C18.4625 19.3755 18.3163 19.4163 18.1672 19.4149H2.79422C2.64755 19.4123 2.50474 19.3697 2.38277 19.2923C2.2608 19.2149 2.1648 19.1058 2.10617 18.978C2.04754 18.8503 2.02875 18.7092 2.05203 18.5716C2.07532 18.434 2.1397 18.3057 2.23752 18.2018L2.2937 18.1387L4.01487 15.9843C4.23978 15.6896 4.35967 15.3343 4.35706 14.9702V7.8714C4.35705 7.11914 4.51335 6.37427 4.81698 5.67951C5.12061 4.98476 5.5656 4.35377 6.12644 3.82275C6.68728 3.29172 7.35294 2.87109 8.08525 2.58498C8.81755 2.29887 9.6021 2.15291 10.3939 2.15547H10.6901C12.258 2.25358 13.7263 2.92003 14.7918 4.01717C15.8572 5.11431 16.4385 6.55832 16.4154 8.05093V14.747C16.4154 15.1182 16.5427 15.4793 16.778 15.7757L18.6882 18.163L18.7393 18.2164C18.842 18.3195 18.91 18.4494 18.9345 18.5894C18.9591 18.7294 18.9391 18.8732 18.8772 19.0024L18.8669 18.9782Z"
              fill="#C2D0E3"
            />
            <path
              d="M18.8669 18.9782C18.8091 19.1087 18.7117 19.22 18.5871 19.2978C18.4625 19.3755 18.3163 19.4163 18.1672 19.4149H2.79422C2.64755 19.4123 2.50474 19.3697 2.38277 19.2923C2.2608 19.2149 2.1648 19.1058 2.10617 18.978C2.04754 18.8503 2.02875 18.7092 2.05203 18.5716C2.07532 18.434 2.1397 18.3057 2.23752 18.2018L2.2937 18.1387L4.01487 15.9843C4.23978 15.6896 4.35967 15.3343 4.35706 14.9702V7.8714C4.35705 7.11914 4.51335 6.37427 4.81698 5.67951C5.12061 4.98476 5.5656 4.35377 6.12644 3.82275C6.68728 3.29172 7.35294 2.87109 8.08525 2.58498C8.81755 2.29887 9.6021 2.15291 10.3939 2.15547H10.6901C12.258 2.25358 13.7263 2.92003 14.7918 4.01717C15.8572 5.11431 16.4385 6.55832 16.4154 8.05093V14.747C16.4154 15.1182 16.5427 15.4793 16.778 15.7757L18.6882 18.163L18.7393 18.2164C18.842 18.3195 18.91 18.4494 18.9345 18.5894C18.9591 18.7294 18.9391 18.8732 18.8772 19.0024L18.8669 18.9782Z"
              fill="#C2D0E3"
            />
            <path
              d="M13.5094 23.9344C13.1261 24.3426 12.6563 24.6692 12.1309 24.8929C11.6054 25.1166 11.0361 25.2322 10.4603 25.2322C9.88452 25.2322 9.31523 25.1166 8.78976 24.8929C8.2643 24.6692 7.79452 24.3426 7.41124 23.9344C7.28864 23.7892 7.22924 23.6049 7.24524 23.4194C7.26124 23.2339 7.35143 23.0613 7.49727 22.937C7.64311 22.8128 7.83352 22.7463 8.02936 22.7513C8.22519 22.7563 8.41157 22.8324 8.55017 22.9639C8.78974 23.2197 9.08358 23.4243 9.41235 23.5645C9.74113 23.7046 10.0974 23.7771 10.4578 23.7771C10.8181 23.7771 11.1744 23.7046 11.5032 23.5645C11.8319 23.4243 12.1258 23.2197 12.3653 22.9639C12.5039 22.8324 12.6903 22.7563 12.8862 22.7513C13.082 22.7463 13.2724 22.8128 13.4182 22.937C13.5641 23.0613 13.6543 23.2339 13.6703 23.4194C13.6863 23.6049 13.6269 23.7892 13.5043 23.9344H13.5094Z"
              fill="#C2D0E3"
            />
          </svg>
          <span className="mr-3 text-lg font-medium font-IRANSans text-dark-6">پیام ها</span>
        </div>

        <div className="px-4 py-3 mt-1 bg-white ">
          <div className="flex flex-row-reverse gap-1 bg-[#f4f4f4] px-2 py-1 rounded-lg ">
            <div
              onClick={() => {
                setNotificationType("system");
              }}
              className={`flex cursor-pointer px-4 py-1.5 flex-1 flex-row-reverse items-center  justify-between rounded ${isAdmin === "system" ? " bg-[#FEFEFE]" : null
                }`}
            >
              <span
                className={`font-IRANSans text-sm font-medium ${isAdmin === "system" ? "text-blue-1" : "text-[#B6B7B8]"
                  }  `}
              >
                سیستم
              </span>
              <span
                className={`px-[2px] min-w-[24px] min-h-[24px] text-center text-sm rounded ${isAdmin === "system" ? "bg-[#eaf2ff] text-blue-1" : "bg-[#E3E4E5] text-dark-5"
                  }`}
              >
                {isAdmin === "system" ? valueDefault.length : 0}
              </span>
            </div>
            <div
              onClick={() => {
                setNotificationType("business");
              }}
              className={`flex cursor-pointer px-4 py-1.5 flex-1 flex-row-reverse items-center justify-between rounded ${isAdmin === "business" ? " bg-[#FEFEFE]" : null
                }`}
            >
              <span
                className={`font-IRANSans text-sm font-medium ${isAdmin === "business" ? "text-blue-1" : "text-[#B6B7B8]"
                  }  `}
              >
                کسب و کار
              </span>
              <span
                className={`px-[2px] min-w-[24px] min-h-[24px] text-center text-sm rounded ${isAdmin === "business" ? "bg-[#eaf2ff] text-blue-1" : "bg-[#E3E4E5] text-dark-5"
                  }`}
              >
                {isAdmin === "business" ? valueDefault.length : 0}
              </span>
            </div>
          </div>
        </div>

        {isAdmin === "business" && <ContainedTabs
          tabs={[
            { label: "خوانده نشده", activeColor: "#1062D0", badge: !isRead ? `${valueDefault.length ? '(' + valueDefault.length + ')' : ''}` : "" },
            { label: "خوانده شده", activeColor: "#1062D0", badge: isRead ? `(${valueDefault.length})` : "" },
          ]}
          centered={true}
          onChange={(val) => {
            setIsRead(val === 1)
            dispatch(apiGetNotifications(businessState.business.token, val));
            // val !== undefined && setActive(val)
          }}
          size={1}
          minWidth={150}
          // styles={ {tab:{margin:10}}}
          withBorder
        />}
        <PerfectScrollbar
          style={{
            width: "100%",
            height: '76%',
            overflowY: "scroll"
          }}
        >
          <div dir="rtl" className="flex flex-col mt-1" key={1}>
            {valueDefault.map((item, key) => {
              return (
                <div key={key} className="relative">
                  <div
                    onClick={() => targetNavigation(item)}
                    key={key}
                    className="flex flex-col items-start py-4 mb-1 bg-white cursor-pointer px-9 "
                  >
                    <span className="text-sm text-black font-IRANSans ">{item.message}</span>
                    <span className="mt-4 text-xs font-normal font-IRANSans text-dark-5">
                      {getLastSyncDifference(item.createdAt)}
                    </span>
                  </div>
                  {!item.is_read ? (
                    <div className="absolute w-2 h-2 rounded-full bg-blue-1 right-3 top-3" />
                  ) : null}
                </div>
              );

            })}
          </div>
        </PerfectScrollbar>
        {valueDefault.some(x => x.is_read === false) ? <div key={"readAll"} className="absolute  bottom-0 w-full">
          <div
            onClick={() => readNotif(0, true)}
            key={"12key"}
            className=" flex flex-row items-center gap-2 py-4 mb-1 mr-auto ml-auto  w-3/4 rounded-xl  text-white bg-blue-1 hover:bg-white hover:text-black cursor-pointer px-9 place-content-center "
          >
            <span className="text-sm font-IRANSans text-center">مشاهده همه </span>
            <span className="text-sm font-IRANSans text-center"><EyeIcon /></span>

          </div>
        </div> : null}
      </div>
    </>
  );
}

export const getLastSyncDifference = (lastSync: string, isTime = true) => {
  try {
    let time = "";
    if (lastSync) {
      const today = momentJalaali();
      const lastSyncDate = momentJalaali(lastSync);
      const lastSyncMinutes = parseInt((today.diff(lastSyncDate) / 60000).toString());

      if (lastSyncMinutes > 720) {
        if (isTime) {
          time = momentJalaali(lastSync).format("HH:mm jYYYY/jM/jD") ?? "";
        } else {
          time = momentJalaali(lastSync).format("jYYYY/jM/jD") ?? "";
        }
      } else if (lastSyncMinutes < 3) {
        time = `لحظاتی پیش`;
      } else if (lastSyncMinutes < 60) {
        time = `${lastSyncMinutes} دقیقه پیش`;
      } else {
        time = `${parseInt((lastSyncMinutes / 60).toString())} ساعت پیش`;
      }
    }
    return time;
  } catch (error) {
    return "00:00";
  }
};
